import SubstitutionProduct from '~/models/Product/SubstitutionProduct'
import Product from '~/models/Product/Product'

export const transformSubstitutionProductToProduct = (product: SubstitutionProduct): Product => {
    return {
        id: product.id,
        name: product.title,
        title: null,
        price: product.price,
        priceBeforeDiscount: product.oldPrice,
        lowestPrice: null,
        availabilityPeriod: 0,
        amountInStock: product.amountInStock,
        image: product.img,
        imageCdn: product.img,
        serviceImage: product.img,
        imageBySize: {
            imageCdn120: product.img,
            imageCdn160: product.img,
            imageCdn240: product.img,
            imageCdn320: product.img,
        },
        status: 1,
        isAvailable: product.isAvailable,
        hasExpiration: false,
        rate: 0,
        description: '',
        attributes: {
            addonSalePrice: 0,
            isInBonus: false,
            isInTv: false,
            isRecommended: false,
            isRegulated: false,
            isInAction: false,
            isFreeSale: false,
            isGift: false,
            isGiftReward: false,
            hasFreeDelivery: false,
            hasExtendedWarranty: false,
            isPilulkaCar: false,
            isPharmacyPickupAvailable: false,
            isSoldByPharmacy: false,
            isFavorite: false,
            maxAmountPerOrder: 0,
            isForAdultsOnly: false,
            isCartSubstitutionsDisabled: false,
            outOfStockGreyedOut: false,
            addOnProducts: [],
            machineLearningAddOnProducts: [],
            rrp: product.oldPrice,
            comparablePrice: null,
            hasCategoryComparablePriceSort: false,
        },
        priceFrom: null,
        percentDiscount: null,
        availabilityText: product.availability,
        hasSuperPrice: false,
        hasCompetitorSuperPrice: false,
        isService: product.isService,
        availabilityTextColor: '',
        availabilityModalEnabled: product.availabilityModalEnabled,
        isDeliveryPostponedForAmountInCart: false,
        visualTags: {
            productVisualTagsAsBenefits: [],
            productVisualTagsBadges: [],
            merged: [],
        },
        service: {},
        url: product.url,
        brandName: null,
        manufacturerName: null,
        categoryNames: [],
        giftActions: [],
        cashbackLabel: '',
        expirationDate: null,
        priceNoVat: product.price,
        originalPriceNoVat: null,
        averageRating: 0,
        productRating: null,
        productCodeSale: null,
        substitutions: null,
        isPreorder: false,
        mobileAppPrice: product.price,
        mobileAppPriceForLoggedInUser: product.price,
        hasMobileAppAction: false,
        pharmacyDealPrice: null,
        pharmacyDealDescription: null,
        variantsCount: 0,
        pricePerPiece: null,
        type: null,
        lastItemsOnStockMessage: null,
        amountPrices: [],
        packSizeHumanReadableValue: '',
        isSponsored: false,
        vat: 0,
        isPremiumExclusive: false,
        premiumDealPrice: null,
        premiumDealDescription: null,
    }
}
